import React from 'react';
import classnames from 'classnames';
import { node, string, bool } from 'prop-types';

const Icon = ({
  children,
  className,
  dark,
  light,
  inactive,
  button,
  ...props
}) => (
  <i
    className={classnames(
      'material-icons',
      {
        'md-dark': dark,
        'md-light': light,
        'md-inactive': inactive,
        'mdc-button__icon': button,
      },
      className,
    )}
    {...props}
  >
    {children}
  </i>
);

Icon.propTypes = {
  children: node.isRequired,
  className: string,
  dark: bool,
  light: bool,
  inactive: bool,
  button: bool,
};

Icon.defaultProps = {
  className: '',
  dark: false,
  light: false,
  inactive: false,
  button: false,
};

export default Icon;
